<template>
  <div style=" background-color: #212f52; height: content-box">
    <div style="height: 70px;display: flex;align-items: center;" class="topInfo">
      <img src="../../assets/Python.png" width="40px" height="40px" style="margin-left: 20px">
      <div style="font-size: 18px; margin-left: 10px; color: white"> Python函数参数传递可视化虚拟仿真实验</div>
    </div>
    <el-main style="font-size: 12px; ">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in pageData" :key="item.id" :label="item.name" :name="item.name">
          <component :is="item.content" :itemData="item.data" v-if="activeName === item.name"></component>
        </el-tab-pane>
      </el-tabs>
    </el-main>
  </div>
</template>

<script>
import lwgl01 from "./lwgl01.vue";
import lwgl02 from "./lwgl02.vue";
import lwgl03 from "./lwgl03.vue";
export default {
  data() {
    return {
      activeName: "Python中的函数参数传递机制",
      pageData: [
        {
          id: "t01",
          name: "Python中的函数参数传递机制",
          content: "lwgl01",
          data: "Python中的函数参数传递机制"
        },
        {
          id: "t02",
          name: "Python中深、浅拷贝",
          content: "lwgl02",
          data: "Python中深、浅拷贝"
        },
        {
          id: "t03",
          name: "Python中的赋值(复制)、浅拷贝与深拷贝",
          content: "lwgl03",
          data: "Python中的赋值(复制)、浅拷贝与深拷贝"
        }
      ]
    }
  },
  components: {
    lwgl01,
    lwgl02,
    lwgl03
  },
  props: ["itemData"]
};
</script>

<style lang="less" scoped>
  .topInfo {
    background-image: url("../../assets/topbg.png");
  }
  .el-main {
    padding-top: 10px;
  }

  /deep/ .el-tabs__item {
    color: white;
  }
  /deep/ .el-tabs__item.is-active {
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/lw/index.vue